import { render, staticRenderFns } from "./Rulex.vue?vue&type=template&id=2ddc81a0&scoped=true"
import script from "./Rulex.vue?vue&type=script&lang=js"
export * from "./Rulex.vue?vue&type=script&lang=js"
import style0 from "./Rulex.vue?vue&type=style&index=0&id=2ddc81a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc81a0",
  null
  
)

export default component.exports